export const simulationBackend = {
  jobs: `${process.env.REACT_APP_API_URL}/api/jobs`,
  countries: `${process.env.REACT_APP_API_URL}/api/countries`,
  simulations: `${process.env.REACT_APP_API_URL}/api/simulations`,
  nodePools: `${process.env.REACT_APP_API_URL}/api/node-pools`,
  support: `${process.env.REACT_APP_API_URL}/api/support`,
  statistics: `${process.env.REACT_APP_API_URL}/api/statistics`,
  authentication: `${process.env.REACT_APP_OAUTH_URL}/oauth/login`
};
